import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/products', label: 'Ürünler' },
    { path: '/services', label: 'Hizmetler' },
    { path: '/about', label: 'Hakkımızda' },
    { path: '/ai-recommendation', label: 'Klima Öneri' },
    { path: '/contact', label: 'İletişim' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="/logo.png"
              alt="Koctech Logo"
              className="h-14 w-auto object-contain transform group-hover:scale-105 transition-transform duration-300 lg:h-14 md:h-12"
              style={{ maxHeight: '56px' }}
            />
            <div>
              <span className="font-bold text-xl text-gray-900">Koctech</span>
              <span className="block text-sm text-teal-600 font-medium">İklimlendirme</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  location.pathname === link.path
                    ? 'bg-teal-500 text-white shadow-md'
                    : 'text-gray-700 hover:bg-teal-50 hover:text-teal-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Contact Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:05516380934" className="flex items-center space-x-2 text-teal-600 hover:text-teal-700 transition-colors duration-300">
              <Phone className="w-5 h-5" />
              <span className="font-semibold">0551 638 09 34</span>
            </a>
            <Link to="/contact">
              <Button className="bg-teal-500 hover:bg-teal-600 text-white shadow-lg hover:shadow-xl transition-all duration-300">
                İletişime Geç
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-300"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200 bg-white">
            <div className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 ${
                    location.pathname === link.path
                      ? 'bg-teal-500 text-white'
                      : 'text-gray-700 hover:bg-teal-50 hover:text-teal-600'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <a href="tel:05516380934" className="px-4 py-3 flex items-center space-x-2 text-teal-600 hover:bg-teal-50 rounded-lg transition-colors duration-300">
                <Phone className="w-5 h-5" />
                <span className="font-semibold">0551 638 09 34</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;